/**
 * Created with IntelliJ IDEA.
 * User: abahlk
 * Date: 12.07.13
 * Time: 10:16
 * To change this template use File | Settings | File Templates.
 */

import { ExternalLoggingConstants } from "../ExternalLoggingConstants";
import { AbstractLogObject } from "../logObjects/AbstractLogObject";
import { BasicLogObjectFactory } from "./BasicLogObjectFactory";

export class SocketErrorLOFactory extends BasicLogObjectFactory {
    public static PING_TEST_IO_ERROR: number = 15001;
    public static PING_TEST_SECURITY_ERROR: number = 15002;
    public static POLICY_PING_TEST_IO_ERROR: number = 15003;
    public static POLICY_PING_TEST_SECURITY_ERROR: number = 15004;

    private static SOCKET_ERROR: number = 15;

    private static PARAM_IP: string = "ip";
    private static PARAM_PORT: string = "port";
    private static PARAM_BLUEBOX: string = "bluebox";

    private _ip: string;
    private _port: number;
    private _zone: string;
    private _operationText: string;
    private _bluebox: number;

    constructor(subErrorId: number, ip: string, port: number, zone: string, operationText: string, bluebox: number) {
        super();

        this._subErrorId = subErrorId;
        this._ip = ip;
        this._port = port;
        this._zone = zone;
        this._operationText = operationText;
        this._bluebox = bluebox;
    }

    public create(): AbstractLogObject {
        // Build the commonData
        let lo: AbstractLogObject = super.create();

        // Update with customData
        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_EVENT_ID, SocketErrorLOFactory.SOCKET_ERROR.toString());

        lo.logData.set(ExternalLoggingConstants.PARAM_ERROR_EVENT_OPERATION_TEXT, this._operationText);
        lo.logData.set(ExternalLoggingConstants.PARAM_ZONE, this._zone);
        lo.logData.set(SocketErrorLOFactory.PARAM_IP, this._ip);
        lo.logData.set(SocketErrorLOFactory.PARAM_PORT, this._port.toString());
        lo.logData.set(SocketErrorLOFactory.PARAM_BLUEBOX, this._bluebox.toString());

        return lo;
    }
}
